import React, { useId } from 'react'
import { SuperGrain } from '../SuperGrain'

export const BlueSphereTop = ({
  hideGrain,
  svgProps,
}: {
  hideGrain?: boolean
  svgProps: React.SVGProps<SVGSVGElement>
}) => {
  const uniqueId = useId()
  const maskId = `grainFilter-blue-sphere-top-${uniqueId}`

  return (
    <svg
      {...svgProps}
      viewBox="0 0 2658 1267"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4716_2179)">
        <g filter="url(#filter0_f_4716_2179)">
          <ellipse
            cx="1155.7"
            cy="1118.35"
            rx="1155.7"
            ry="1118.35"
            transform="matrix(0.999999 1.7202e-07 -1.50669e-06 1 178.576 284)"
            fill="url(#paint0_radial_4716_2179)"
          />
        </g>
        <g filter="url(#filter1_f_4716_2179)">
          <ellipse
            cx="1070.89"
            cy="1036.29"
            rx="1070.89"
            ry="1036.29"
            transform="matrix(0.999999 1.7202e-07 -1.50669e-06 1 263.376 366.062)"
            fill="url(#paint1_radial_4716_2179)"
          />
        </g>
        <g filter="url(#filter2_f_4716_2179)">
          <ellipse
            cx="1013.69"
            cy="956.888"
            rx="1013.69"
            ry="956.888"
            transform="matrix(0.999999 1.7202e-07 -1.50669e-06 1 320.582 469.512)"
            fill="url(#paint2_radial_4716_2179)"
          />
        </g>
        <g filter="url(#filter3_d_4716_2179)">
          <ellipse
            cx="815.38"
            cy="789.032"
            rx="815.38"
            ry="789.032"
            transform="matrix(0.999998 -0.00184243 0.00196626 0.999999 517.338 588.821)"
            fill="url(#paint3_radial_4716_2179)"
          />
        </g>
        <g filter="url(#filter4_f_4716_2179)">
          <circle
            cx="1338.27"
            cy="1388.74"
            r="770.392"
            fill="white"
            fillOpacity="0.8"
          />
        </g>
        <g filter="url(#filter5_f_4716_2179)">
          <circle cx="1334.27" cy="1412.74" r="708.76" fill="#176AE5" />
        </g>
        <g filter="url(#filter6_f_4716_2179)">
          <circle cx="1334.27" cy="1379.1" r="390.292" fill="#81D3FF" />
        </g>
        <g filter="url(#filter7_f_4716_2179)">
          <circle
            cx="1334.27"
            cy="1399.74"
            r="973.126"
            stroke="#F9EFE4"
            strokeWidth="1.59202"
          />
        </g>
        <g
          filter="url(#filter8_f_4716_2179)"
          data-figma-bg-blur-radius="8.02838"
        >
          <path
            d="M2430.65 1132.72L1464.47 871.861L498.289 611L265 1475.06L2197.36 1996.78L2430.65 1132.72Z"
            fill="url(#paint4_linear_4716_2179)"
            fillOpacity="0.01"
          />
        </g>
        <g
          filter="url(#filter9_f_4716_2179)"
          data-figma-bg-blur-radius="8.02838"
        >
          <path
            d="M1665.88 345.644L1541.85 329.74L315.417 635.321L1665.88 542.827L1861.32 495.226L2114.32 345.644L1665.88 345.644Z"
            fill="url(#paint5_linear_4716_2179)"
            fillOpacity="0.01"
          />
        </g>
        <g filter="url(#filter10_f_4716_2179)">
          <circle
            cx="17.1299"
            cy="17.1299"
            r="17.1299"
            transform="matrix(-1.19249e-08 -1 -1 1.19249e-08 1698.88 508.733)"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_4716_2179"
          x="140.92"
          y="246.346"
          width="2386.7"
          height="2312.01"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="18.8271"
            result="effect1_foregroundBlur_4716_2179"
          />
        </filter>
        <filter
          id="filter1_f_4716_2179"
          x="215.61"
          y="318.298"
          width="2237.32"
          height="2168.11"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="23.8821"
            result="effect1_foregroundBlur_4716_2179"
          />
        </filter>
        <filter
          id="filter2_f_4716_2179"
          x="216.649"
          y="365.581"
          width="2235.24"
          height="2121.64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="51.9656"
            result="effect1_foregroundBlur_4716_2179"
          />
        </filter>
        <filter
          id="filter3_d_4716_2179"
          x="454.974"
          y="497.838"
          width="1758.59"
          height="1705.89"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-25.5657" />
          <feGaussianBlur stdDeviation="31.9571" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4716_2179"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4716_2179"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_f_4716_2179"
          x="523.976"
          y="574.446"
          width="1628.58"
          height="1628.58"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="21.95"
            result="effect1_foregroundBlur_4716_2179"
          />
        </filter>
        <filter
          id="filter5_f_4716_2179"
          x="461.303"
          y="539.775"
          width="1745.93"
          height="1745.93"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="82.1022"
            result="effect1_foregroundBlur_4716_2179"
          />
        </filter>
        <filter
          id="filter6_f_4716_2179"
          x="533.466"
          y="578.297"
          width="1601.61"
          height="1601.61"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="205.255"
            result="effect1_foregroundBlur_4716_2179"
          />
        </filter>
        <filter
          id="filter7_f_4716_2179"
          x="356.874"
          y="422.348"
          width="1954.79"
          height="1954.79"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.73556"
            result="effect1_foregroundBlur_4716_2179"
          />
        </filter>
        <filter
          id="filter8_f_4716_2179"
          x="53.8352"
          y="399.835"
          width="2587.98"
          height="1808.11"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="105.582"
            result="effect1_foregroundBlur_4716_2179"
          />
        </filter>
        <clipPath
          id="bgblur_1_4716_2179_clip_path"
          transform="translate(-53.8352 -399.835)"
        >
          <path d="M2430.65 1132.72L1464.47 871.861L498.289 611L265 1475.06L2197.36 1996.78L2430.65 1132.72Z" />
        </clipPath>
        <filter
          id="filter9_f_4716_2179"
          x="104.252"
          y="118.575"
          width="2221.23"
          height="727.911"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="105.582"
            result="effect1_foregroundBlur_4716_2179"
          />
        </filter>
        <clipPath
          id="bgblur_2_4716_2179_clip_path"
          transform="translate(-104.252 -118.575)"
        >
          <path d="M1665.88 345.644L1541.85 329.74L315.417 635.321L1665.88 542.827L1861.32 495.226L2114.32 345.644L1665.88 345.644Z" />
        </clipPath>
        <filter
          id="filter10_f_4716_2179"
          x="1657.88"
          y="467.727"
          width="47.7526"
          height="47.7526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="3.37322"
            result="effect1_foregroundBlur_4716_2179"
          />
        </filter>
        <radialGradient
          id="paint0_radial_4716_2179"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1155.69 644.425) rotate(89.9999) scale(2161.77 2233.96)"
        >
          <stop offset="0.305" stopColor="#176BE5" />
          <stop offset="0.629788" stopColor="#EEBACB" />
          <stop offset="0.744002" stopColor="white" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_4716_2179"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1070.89 597.139) rotate(89.9999) scale(2003.15 2070.04)"
        >
          <stop offset="0.305" stopColor="#83D4FF" />
          <stop offset="0.629788" stopColor="#EEBACB" />
          <stop offset="0.744002" stopColor="white" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_4716_2179"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1013.69 551.386) rotate(89.9999) scale(1849.67 1959.47)"
        >
          <stop offset="0.305" stopColor="#ECB9CB" />
          <stop offset="0.629788" stopColor="#EEBACB" />
          <stop offset="0.744002" stopColor="white" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_4716_2179"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(815.585 684.685) rotate(90.0132) scale(893.379 923.212)"
        >
          <stop offset="0.205439" stopColor="#2877E7" />
          <stop offset="0.674426" stopColor="#75A8F0" />
          <stop offset="0.843487" stopColor="#B1CEF6" />
          <stop offset="0.93127" stopColor="#C9DDF9" />
          <stop offset="1" stopColor="white" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_4716_2179"
          x1="1454.15"
          y1="38.8093"
          x2="1328.88"
          y2="502.771"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_4716_2179"
          x1="1244.86"
          y1="109.616"
          x2="1386.53"
          y2="265.627"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
        <clipPath id="clip0_4716_2179">
          <rect width="2658" height="1267" fill="white" />
        </clipPath>
        <mask id={maskId}>
          <rect width="100%" height="100%" fill="black" />
          <g filter="url(#filter0_f_4716_2179)">
            <ellipse
              cx="1155.7"
              cy="1118.35"
              rx="1155.7"
              ry="1118.35"
              transform="matrix(0.999999 1.7202e-07 -1.50669e-06 1 178.576 284)"
              fill="white"
            />
          </g>
          <g filter="url(#filter1_f_4716_2179)">
            <ellipse
              cx="1070.89"
              cy="1036.29"
              rx="1070.89"
              ry="1036.29"
              transform="matrix(0.999999 1.7202e-07 -1.50669e-06 1 263.376 366.062)"
              fill="white"
            />
          </g>
          <g filter="url(#filter2_f_4716_2179)">
            <ellipse
              cx="1013.69"
              cy="956.888"
              rx="1013.69"
              ry="956.888"
              transform="matrix(0.999999 1.7202e-07 -1.50669e-06 1 320.582 469.512)"
              fill="white"
            />
          </g>
          <g filter="url(#filter3_d_4716_2179)">
            <ellipse
              cx="815.38"
              cy="789.032"
              rx="815.38"
              ry="789.032"
              transform="matrix(0.999998 -0.00184243 0.00196626 0.999999 517.338 588.821)"
              fill="white"
            />
          </g>
          <g filter="url(#filter4_f_4716_2179)">
            <circle cx="1338.27" cy="1388.74" r="770.392" fill="white" />
          </g>
          <g filter="url(#filter5_f_4716_2179)">
            <circle cx="1334.27" cy="1412.74" r="708.76" fill="white" />
          </g>
          <g filter="url(#filter6_f_4716_2179)">
            <circle cx="1334.27" cy="1379.1" r="390.292" fill="white" />
          </g>
        </mask>
      </defs>
      {!hideGrain && (
        <foreignObject
          x="0"
          y="0"
          width="100%"
          height="100%"
          mask={`url(#${maskId})`}
        >
          <SuperGrain zIndex={0} />
        </foreignObject>
      )}
    </svg>
  )
}
